<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<app-header></app-header>
<div class="bkgrcolor">
  <div class="container-fluid">
    <div class="row no-pad mar-tb-20">
      <h2 class="col-md-6">{{'Planned Maintenance Scheduler' | translate}}</h2>
    </div>
  </div>
</div>
<section class=" row parts_container">
  <div class="col-md-12">
    <div class="row_title pad-btm-20">{{'Create Maintenance Schedule' | translate}}</div>
    <form name="form" (ngSubmit)="maintanenceRegister()" #f="ngForm" novalidate>
      <div class="container-fluid mar-top-10 row" style="padding: 0px;">

        <div class="form-group col-md-4" style="padding: 0px 16px;">
          <label for="message">{{'Message' | translate}}</label>
          <span class="minchar">({{'Max.Limit 250 characters' | translate}})</span>
          <textarea class="textarea-dimension form-control" name="message" [(ngModel)]="model.message" #message="ngModel"
            placeholder="Enter Message here..." maxlength="250"></textarea>

        </div>
        <div class="form-group col-md-4">
          <label for="comment">{{'COMMENTS' | translate}}</label>
          <span class="minchar">(Max.Limit 250 characters)</span>
          <textarea class="textarea-dimension form-control" placeholder="Enter Comment here..." name="comment"
            [(ngModel)]="model.comment" #comment="ngModel" maxlength="250"></textarea>

        </div>
        <div class="form-group col-md-3">
          <div class="pad-top-10">
            <div><label for="time">{{'Scheduled From Date' | translate}}</label></div>
            <!-- <input readonly placeholder="Date Time" name="dateTime" [(ngModel)]="dateTimeRange" [owlDateTimeTrigger]="dt"
              [owlDateTime]="dt" class="timeDateInput form-control">
            <owl-date-time #dt></owl-date-time> -->
            <p-calendar [(ngModel)]="dateTimeRange" [showTime]="true" [showSeconds]="true"></p-calendar>
          </div>
          <div class="pad-top-10">
            <div><label for="time">{{'Scheduled To Date' | translate}}</label></div>

            <!-- <input readonly placeholder="Date Time" name="dateTimeDown" [(ngModel)]="dateTimeRangeDown"
              [owlDateTimeTrigger]="ut" [owlDateTime]="ut" class="timeDateInput form-control">
            <owl-date-time #ut></owl-date-time> -->
            <p-calendar [(ngModel)]="dateTimeRangeDown" [showTime]="true" [showSeconds]="true"></p-calendar>
          </div>
        </div>
        <div class="form-group col-md-1 align-self-center">
          <button class="btn btn-primary black" (click)="editRowDetails(editDetails, dateTimeRange)" [disabled]="!model.message || !model.comment  || !dateTimeRange || !dateTimeRangeDown ">{{'Publish'
            | translate}}</button>
        </div>
      </div>
    </form>


  </div>

  <!-- <div class=" col-md-2 paddingder">

  </div> -->
</section>
<section class="part_search_bar">
</section>
<section class="parts_container">
  <div class="row_title mar-tb-10">{{'Existing Maintenance Schedule' | translate}}</div>
  <div class="row pad-btm-20">
    <div class="col-md-12">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-white table-striped table-bordered">
        <thead>
          <tr>
            <th>{{'Message' | translate}}</th>
            <th>{{'COMMENTS' | translate}}</th>
            <th>{{'Start Time' | translate}}</th>
            <th>{{'End Time' | translate}}</th>
            <th>{{'Operation' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of maintainceList ">
            <td>{{ item.message}}</td>
            <td>
              <div>{{ item.comments}}</div>
            </td>
            <td>
              <div>{{ item.fromDownDate}} {{item.fromDownTime}} </div>
            </td>
            <td>
              <div>{{ item.toDownDate}} {{item.toDownTime}}</div>
            </td>
            <td>
              <!-- <button class="btn btn-light"  type="button" (click)="deleteFieldValue(item.pkId)">Delete Item </button> -->
              <button class="btn btn-primary black" (click)="deleteRowDetails(deleteDetails,item.pkId, item.message)">{{'DELETE'
                | translate}}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #editDetails let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">{{'Edit Details' | translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      Planned Maintainence / メンテナンス <br />
      Date, Time / 日程: {{dateTimeRange | date:'yyyy-MM-dd HH:mm'}} to {{dateTimeRangeDown | date:'yyyy-MM-dd HH:mm'}}
      <br />
      LogBase will be unavailable in the above stated time frame. We apologize for the inconvenience.<br />
      上記の時間帯に、メンテナンスのため、LogBaseをご利用頂くことができません。ご迷惑をおかけしますが、ご理解とご協力を宜しくお願いいたします。<br />
      {{model.message}}
    </div>
    <div class="modal-footer">
      <button type="button" class="col-md-2  btn btn-dark" (click)="maintanenceRegister()">{{'Publish' | translate}}</button>
      <button type="button" class="col-md-2 btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
    </div>
  </ng-template>


  <ng-template #deleteDetails let-c="close" let-d="dismiss">
    <div class="modal-body">
      {{'Are you sure you want to delete' | translate }}{{delSelmsg}}?
    </div>
    <div class="modal-footer">
      <button type="button" class="col-md-2  btn btn-dark" (click)="deleteFieldValue()">{{'DELETE' | translate}}</button>
      <button type="button" class="col-md-2 btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
    </div>
  </ng-template>

</section>